<div class="outer-content">
  <div class="float-left bg-white card-background">
    <div class="header">
      <h1 class="header-text responsive-text-8" id="online-quote">
        {{contentData.header}}
      </h1>
    </div>

    <div class="container">
      <div class="content-container">
        <div class="content">
          <ul class="list-tick responsive-text-4">
            <li [(value)]="contentData.landingPageQuoteText[i]"
              *ngFor="let txt of contentData.landingPageQuoteText; let i = index">
              {{txt}}
            </li>
          </ul>
        </div>

        <div class="image-container">
          <img src="{{contentData.landingPageIcon}}" alt="Moneyfacts Awards Best Annuity Provider 2020 - 2022">
        </div>
      </div>

      <div class="quote-container">
        <div class="btn-container new-quote-cnt">
          <button class="btn btn-primary new-quote responsive-text-4" (click)="onRegister()">New Quote</button>
        </div>

        <div class="btn-container previous-quote-cnt">
          <button class="btn btn-primary previous-quote responsive-text-4" (click)="onLogin()">Retrieve Previous
            Quote</button>
        </div>
      </div>

      <div class="more-info" (click)="toggleCollapse()">
        <div class="arrow" [class.down]="isExpanded"></div>
        <span class="info_text responsive-text-4">{{contentData.loadmore_txt}}</span>
      </div>
      <div class="info" [class.expanded]="isExpanded">
        <p class="info-title responsive-text-4">{{contentData.essential_docs}}</p>
        <ul class="list-dash responsive-text-4">
          <li [(value)]="contentData.essentialDocsText[i]"
            *ngFor="let txt of contentData.essentialDocsText; let i = index">
            {{txt}}
          </li>
        </ul>

        <p class="info-title responsive-text-4">{{contentData.prequote_checklist}}</p>
        <ul class="list-dash responsive-text-4">
          <li [(value)]="contentData.preQuoteChecklistText[i]"
            *ngFor="let txt of contentData.preQuoteChecklistText; let i = index">
            {{txt}}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>